export const securityCompliancePolicy = [

  {
    id: 1,
    title: "1. Introduction",

    content: `
At Magyne Technologies, security is a fundamental part of our
platform design and operations.

This Security & Compliance Policy explains the measures we use
to protect customer information, maintain service reliability,
and ensure responsible handling of data across the Magyne ecosystem.

Our security practices are designed around confidentiality,
integrity, availability and privacy.
`
  },


  {
    id: 2,
    title: "2. Security Principles",

    content: `
Magyne follows these core security principles:

• Confidentiality - ensuring customer information is accessible only
to authorized users.

• Integrity - protecting information from unauthorized modification.

• Availability - maintaining reliable access to services.

• Privacy - handling personal and business information responsibly.

• Least Privilege - providing users only the access required to
perform their responsibilities.
`
  },


  {
    id: 3,
    title: "3. Multi-Tenant Data Isolation",

    content: `
Magyne uses a secure multi-tenant architecture designed to separate
customer environments.

Each registered organization operates within its own isolated
environment.

Security controls include:

• Tenant-specific database isolation.

• Controlled database connection management.

• User-to-tenant access verification.

• Authorization checks before accessing business information.

• Protection against unauthorized cross-tenant access.

Customers can only access information belonging to their authorized
organization.
`
  },


  {
    id: 4,
    title: "4. Identity and Access Management",

    content: `
Magyne implements centralized identity management to securely
authenticate and authorize users.

Security measures include:

• Secure user authentication.

• Encrypted password storage.

• Role-based access control.

• User permission management.

• Session security controls.

• Account activity monitoring.

Customers are responsible for managing user access within their
organization and ensuring credentials remain confidential.
`
  },


  {
    id: 5,
    title: "5. Data Encryption",

    content: `
Magyne uses encryption technologies to protect information during
storage and transmission.

Protection measures include:

• Encryption of sensitive information.

• Secure HTTPS communication.

• Encrypted database credentials.

• Secure handling of authentication tokens.

• Protection of tenant connection information.

Encryption practices are continuously reviewed to maintain strong
security standards.
`
  },


  {
    id: 6,
    title: "6. Application Security",

    content: `
Magyne follows secure software development practices including:

• Input validation.

• Secure API design.

• Authentication and authorization checks.

• Protection against common security vulnerabilities.

• Dependency monitoring.

• Secure coding practices.

Applications are regularly reviewed to identify and address
potential security risks.
`
  },


  {
    id: 7,
    title: "7. Infrastructure Security",

    content: `
Magyne infrastructure is designed with security and reliability
in mind.

Controls include:

• Secure cloud hosting environments.

• Network protection mechanisms.

• Controlled access to production systems.

• Monitoring of system health.

• Regular software updates.

• Backup and recovery procedures.
`
  },


  {
    id: 8,
    title: "8. Data Backup and Recovery",

    content: `
Magyne maintains backup and recovery procedures designed to protect
customer information from accidental loss or system failures.

Backup practices include:

• Regular database backups.

• Secure backup storage.

• Recovery procedures.

• System restoration testing.

Customers are encouraged to maintain appropriate business continuity
procedures.
`
  },


  {
    id: 9,
    title: "9. Monitoring and Incident Response",

    content: `
Magyne monitors systems to identify unusual activities, security
events and potential threats.

In the event of a security incident, Magyne follows an incident
response process that includes:

• Identification of the issue.

• Containment of the threat.

• Investigation and analysis.

• Remediation.

• Customer communication where applicable.
`
  },


  {
    id: 10,
    title: "10. Employee and Internal Access",

    content: `
Access to Magyne systems is restricted to authorized personnel.

Internal security practices include:

• Controlled employee access.

• Access reviews.

• Confidentiality obligations.

• Secure handling of customer information.

Employees are provided access only where required for their roles.
`
  },


  {
    id: 11,
    title: "11. Compliance Commitment",

    content: `
Magyne is committed to operating responsibly and aligning with
applicable data protection, privacy and security requirements.

Our compliance approach includes:

• Protecting customer information.

• Maintaining transparency.

• Supporting customer security requirements.

• Continuously improving security practices.

Specific compliance requirements may vary depending on customer
location, industry and applicable regulations.
`
  },


  {
    id: 12,
    title: "12. Customer Security Responsibilities",

    content: `
Customers also play an important role in maintaining security.

Customers are responsible for:

• Protecting account credentials.

• Managing authorized users.

• Reviewing access permissions.

• Reporting suspicious activity.

• Ensuring users follow acceptable usage practices.
`
  },


  {
    id: 13,
    title: "13. Responsible Disclosure",

    content: `
Magyne encourages responsible reporting of security vulnerabilities.

Security researchers and customers who identify potential security
issues should report them through official communication channels.

We are committed to investigating and addressing legitimate
security concerns.
`
  },


  {
    id: 14,
    title: "14. Policy Updates",

    content: `
Magyne may update this Security & Compliance Policy as technology,
security practices and regulatory requirements evolve.

The latest version will always be made available through official
Magyne communication channels.
`
  },


  {
    id: 15,
    title: "15. Contact Us",

    content: `
For security-related questions, compliance requests or vulnerability
reports, please contact Magyne Technologies through our official
support channels.

We are committed to maintaining a secure and trustworthy platform
for all customers.
`
  }

];
